import {
  BankingLimitsCard,
  BankingLimitsCardType,
} from 'modules/bank/components/account/BankingLimitsCard/BankingLimitsCard'
import { BankingLimitsCardSkeleton } from 'modules/bank/components/account/BankingLimitsCard/BankingLimitsCardSkeleton'
import { Card } from 'modules/bank/types'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { InternalAccountCardError } from '../../InternalAccountCardError/InternalAccountCardError'
import { useInternalCardLimitsQueries } from './useBankCardLimitsQueries'

interface Props {
  currentCard: Card
  isBlockedInvest: boolean
}

export const BankCardLimitsCardContainer: React.FC<Props> = ({
  currentCard,
  isBlockedInvest,
}) => {
  const { t } = useTranslation('bank-components')

  const {
    data: { monthlyLimit, dailyLimit },
    isError,
    isLoading,
    refetch,
  } = useInternalCardLimitsQueries(currentCard)

  const cardType = BankingLimitsCardType.PAYMENT

  if (isError) {
    return (
      <InternalAccountCardError
        title={t('bankingLimitsCard.title', { context: cardType })}
        onReload={refetch}
      />
    )
  }

  if (isLoading || !(dailyLimit && monthlyLimit)) {
    return <BankingLimitsCardSkeleton />
  }

  return (
    <BankingLimitsCard
      type={cardType}
      dailyLimit={dailyLimit}
      monthlyLimit={monthlyLimit}
      isManageLimitsButtonDisabled={isBlockedInvest}
    />
  )
}
